<ng-container *ngIf="user">
  <div class="menu-item px-3">
    <div class="menu-content d-flex align-items-center px-3">
      <div class="symbol symbol-60px me-5" *ngIf="profileImage">
<!--        <img src="./assets/media/svg/avatars/blank.svg" alt="Immagine personale" />-->
        <img [src]="profileImage" alt="Immagine del profilo" appProfileImage/>

      </div>

      <div class="d-flex flex-column">
        <div class="fw-bolder d-flex align-items-center fs-5">
          {{ user.nome }} {{ user.cognome }}

        </div>
        <a class="fw-bold text-muted text-hover-primary fs-7 cursor-pointer">
          {{ user.username }}
        </a>

        <span class="badge badge-light-success fw-bolder fs-8 px-2 py-1 mt-1"
              style="width: min-content;">{{sessionQuery.getValue().role[0]?.name | titlecase}}</span>
      </div>
    </div>
  </div>

  <div class="separator my-2"></div>

  <!--<div class="menu-item px-5">
    <a class="menu-link px-5">
      Il mio account
    </a>
  </div>-->

  <!-- <div class="menu-item px-5">
    <a class="menu-link px-5 cursor-pointer" placement="top-start" ngbTooltip="Coming soon">
      <span class="menu-text">My Projects</span>
      <span class="menu-badge">
        <span class="badge badge-light-danger badge-circle fw-bolder fs-7">3</span>
      </span>
    </a>
  </div> -->

  <!--<div class="menu-item px-5 my-1">
    <a class="menu-link px-5">
      Impostazioni
    </a>
  </div>-->

  <div class="menu-item px-5">
    <a class="menu-link without-sub" routerLink="/il-mio-account" routerLinkActive="active"><span class="menu-title hover">{{"menu.account" | translate}}</span></a>
    <a (click)="logout()" class="menu-link px-5 cursor-pointer"> {{"common.esci" | translate}} </a>
  </div>
</ng-container>
